/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ImportTypeEnum {
    Degiro = 'degiro',
    Etoro = 'etoro',
    XtbOld = 'xtbOld',
    XtbNew = 'xtbNew',
    Trading212 = 'trading212',
    InteractiveBrokers = 'interactiveBrokers',
    Monery = 'monery',
    Coinbase = 'coinbase',
    Anycoin = 'anycoin',
    Portu = 'portu',
    Binance = 'binance',
    Fio = 'fio',
    Snowball = 'snowball',
    YahooFinance = 'yahooFinance',
    Coinmate = 'coinmate',
    Patria = 'patria',
    Lynx = 'lynx',
    CoinbasePro = 'coinbasePro',
    Revolut = 'revolut'
}

export function ImportTypeEnumFromJSON(json: any): ImportTypeEnum {
    return ImportTypeEnumFromJSONTyped(json, false);
}

export function ImportTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTypeEnum {
    return json as ImportTypeEnum;
}

export function ImportTypeEnumToJSON(value?: ImportTypeEnum | null): any {
    return value as any;
}

